import { spacing, ThemeUICSSObject } from '@apia/theme';

const documentsInfo: ThemeUICSSObject = {
  '.collapsiblePanel__label': {
    fontWeight: 'bold',
  },
  '.collapsiblePanel': {
    overflow: 'visible',
  },

  a: {
    display: 'inline-block',
  },

  '.collapsiblePanel__content ': {
    '& > div': {
      p: spacing(4),
    },
  },

  '.permissions': {
    '.collapsiblePanel__content': {
      '& > div': {
        maxHeight: '25vh',
        overflow: 'auto',
        display: 'flex ',
        flexDirection: 'column',
        gap: spacing(4),
      },
    },
  },

  '.modal__content': {
    pr: spacing(3),
    flexDirection: 'column',
    gap: spacing(4),
    minWidth: 'min(70vw,620px)',
  },

  table: {
    '&.generalInfo': {
      borderColor: 'muted',
      margin: 4,
      width: 'calc(100% - 24px)',
    },

    '&.history': {},

    '&.metadata': {},

    '.downloadLink__row': {
      '.downloadLink__wrapper': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        '.copyLink': (theme) => ({
          p: spacing(2),
          color: 'black',
          borderRadius: 2,

          ...theme.palette.getStatesFromDefinition({
            backgroundColor: theme.palette.gray[850],
            color: 'black',
            borderColor: theme.palette.gray[700],
          }),
        }),
      },
    },
  },
};

export default documentsInfo;
